export const ROOT = "_root"
export const TIME_FORMAT = "yyyy-MM-dd|HH"
export const DAY_START = 9
export const DAY_END = 17
export const HOURS_PER_DAY = DAY_END - DAY_START
